import { Component } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PricesService, UtilsService, UxHelperService } from '@shared/services';
import type { TResponse, TPriceStatus, TPricingInfo } from '@shared/models';

@Component({
    'selector': 'app-price',
    'templateUrl': './price.page.html',
    'styleUrls': ['./price.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class PricePage implements OnInit {
    public price: TPricingInfo = {};
    private uid = '';
    public submitted = false;
    public payAsYouGoPackages: any;
    public selectGroupValue = '';

    constructor(private activedRoute: ActivatedRoute, private uxHelperService: UxHelperService,
        private pricesService: PricesService, private utilsService: UtilsService, private location: Location) {
    }

    async ngOnInit() {
        this.uid = this.activedRoute.snapshot.paramMap.get('uid');

        if (this.uid) {
            this.price = await this.pricesService.getByUid(this.uid);
        }
    }

    // public onDeprecatedChange() {
    //     if (this.vm.deprecated) {
    //         this.vm.deprecatedStr = 'No new customers will be allowed to use this pricing package.';
    //     } else {
    //         this.vm.deprecatedStr = 'New customers will be allowed to use this pricing package.';
    //     }
    // }

    public async onStatusClick() {
        const statuses: TPriceStatus[] = ['Active', 'Non-Active'];
        const response = await this.uxHelperService.showRadioAlert('Select User\'s Role', statuses, this.price.status);
        if (response.okay) {
            this.price.status = response.selectedItems[0] as TPriceStatus;
        }
    }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.');
            if (this.uid) {
                await this.pricesService.update(this.price);
            } else {
                await this.pricesService.add(this.price);
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
            this.location.back();
        }
    }
}
